import React, { Component } from 'react'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Upload,
  Icon,
  Select,
  message,
  Spin,
  Tooltip,
  Table
} from 'antd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/jobDrawingActions'
import moment from 'moment'
import _ from 'lodash'

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option
const propTypes = {}

class JobDrawings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      dataSource: ['From Lead', 'Layout Plans', 'Design Plans', 'Submittals'],
      attachmentDetailsVisible: false,
      attachmentId: 0,
      attachmentStatus: '',
      drawings: [],
      drawingAttachments: [],
      drawingFormattedAttachments: [],
      attachmentRevision: 0
    }
  }
  componentDidMount() {
    this.props.jobDrawingsRefresh({
      jobId: this.props.jobId
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.jobDrawingActions.jobDrawings !== prevProps.jobDrawingActions.jobDrawings
    ) {
      const highLightEstimate = _.filter(
        this.props.jobDrawingActions.jobDrawings.data,
        drawing => drawing.id === this.props.shortcutItemId
      )
      this.handleRowClick(highLightEstimate[0])
      this.props.clearHighlight()
    }
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description,
      attachmentStatus: row.status,
      attachmentRevision: row.revision
    })
  }

  handleRowClick = row => {
    this.props.getDrawingAttachments({
      drawingId: row.id
    })
    this.setState({
      modalVisible: true,
      attachmentDetailsVisible: false,
      currentId: row.id,
      contentData: {
        description: row.description,
        type: row.type,
        status: row.status
      }
    })
  }

  onUploadChange = info => {
    if (info.file.status === 'done') {
      if (this.state.currentId !== 0) {
        this.props.addDrawingAttachment({
          filename: info.file.name,
          drawingId: this.state.currentId,
          userId: this.props.user.userId
        })
      }
      // message.success(`${info.file.name} file uploaded successfully`)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (this.state.currentId === 0) {
        this.props.createJobDrawing({
          jobId: this.props.jobId,
          userId: this.props.user.userId,
          description: values.description,
          drawingType: values.type
        })
      } else {
        this.props.updateJobDrawing({
          jobId: this.props.jobId,
          drawingId: this.state.currentId,
          userId: this.props.user.userId,
          description: values.description,
          drawingType: values.type
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteJobDrawing({
      jobId: this.props.jobId,
      drawingId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      drawingId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      status: this.state.attachmentStatus,
      attachmentId: this.state.attachmentId,
      drawingId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  onStatusChange = e => {
    this.setState({
      attachmentStatus: e
    })
  }

  getTableColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type'
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
      },
      {
        title: 'Created By',
        dataIndex: 'created_by',
        key: 'created_by'
      },
      {
        title: 'Updated By',
        dataIndex: 'updated_by',
        key: 'updated_by'
      },
      {
        title: 'Created date',
        dataIndex: 'created_date',
        key: 'created_date',
        render: created_date => moment(created_date).format('M/D/YYYY h:mm:ssa')
      }
    ]
  }

  getAttachmentTableColumns = () => {
    let columns = [
      {
        title: 'Filename',
        dataIndex: 'filename',
        key: 'filename'
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status'
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
      },
      {
        title: 'Created By',
        dataIndex: 'created_by',
        key: 'created_by'
      },
      {
        title: 'Updated By',
        dataIndex: 'updated_by',
        key: 'updated_by'
      },
      {
        title: '',
        dataIndex: 'signedUrl',
        key: 'signedUrl',
        render: signedUrl => (
          <Tooltip placement="left" title="Open this file on a new window">
            <a target="_blank" href={signedUrl}>
              <Icon type="export" className="fontSize20" />
            </a>
          </Tooltip>
        )
      }
    ]
    return columns
  }

  getTableData = () => {
    const drawings = _.get(this.props, 'jobDrawingActions.jobDrawings.data')
    let data = []

    if (drawings && drawings.length > 0) {
      for (const item of drawings) {
        data.push({
          id: item.id,
          type: item.type,
          description: item.description,
          created_by: `${item.created_by_first_name} ${item.created_by_last_name}`,
          updated_by: `${item.updated_by_first_name} ${item.updated_by_last_name}`,
          created_date: item.created_date,
          attachments: item.attachments
        })
      }
    }
    return data
  }

  expandedRowRender = record => {
    if (record.attachments && record.attachments.length > 0) {
      let columns = [
        {
          title: 'Filename',
          dataIndex: 'filename',
          key: 'filename'
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status'
        },
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description'
        },
        {
          title: 'Revision',
          dataIndex: 'revision',
          key: 'revision',
          render: revision => revision || 0
        },
        {
          title: 'Created By',
          dataIndex: 'created_by',
          key: 'created_by'
        },
        {
          title: 'Updated By',
          dataIndex: 'updated_by',
          key: 'updated_by'
        },
        {
          title: '',
          dataIndex: 'signedUrl',
          key: 'signedUrl',
          render: signedUrl => (
            <Tooltip placement="left" title="Open this file on a new window">
              <a target="_blank" href={signedUrl}>
                <Icon type="export" className="fontSize20" />
              </a>
            </Tooltip>
          )
        }
      ]
      const data = record.attachments.map(item => ({
        id: item.id,
        filename: item.filename,
        status: item.status,
        description: item.description,
        created_by: `${item.created_by_first_name} ${item.created_by_last_name}`,
        updated_by: `${item.updated_by_first_name} ${item.updated_by_last_name}`,
        signedUrl: item.signedUrl,
        revision: item.revision
      }))
      return (
        <Table
          rowKey={record => record.id}
          columns={columns}
          dataSource={data}
          pagination={false}
        />
      )
    } else {
      return null
    }
  }

  getAttachmentTableData = attachments => {
    if (!attachments) {
      return []
    }
    return attachments.map(attachment => ({
      id: attachment.id,
      filename: attachment.filename,
      status: attachment.status,
      description: attachment.description,
      created_by: `${attachment.created_by_first_name} ${attachment.created_by_last_name}`,
      updated_by: `${attachment.updated_by_first_name} ${attachment.updated_by_last_name}`,
      signedUrl: attachment.signedUrl,
      revision: attachment.revision,
      revisions: attachment.revisions
    }))
  }

  attachmentExpandedRowRender = record => {
    if (record.revisions) {
      let columns = [
        {
          title: 'Filename',
          dataIndex: 'filename',
          key: 'filename'
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status'
        },
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description'
        },
        {
          title: 'Created By',
          dataIndex: 'created_by',
          key: 'created_by'
        },
        {
          title: 'Updated By',
          dataIndex: 'updated_by',
          key: 'updated_by'
        },
        {
          title: 'Revision',
          dataIndex: 'revision',
          key: 'revision'
        },
        {
          title: '',
          dataIndex: 'signedUrl',
          key: 'signedUrl',
          render: signedUrl => (
            <Tooltip placement="left" title="Open this file on a new window">
              <a target="_blank" href={signedUrl}>
                <Icon type="export" className="fontSize20" />
              </a>
            </Tooltip>
          )
        }
      ]
      const data = record.revisions.map(item => ({
        id: item.id,
        filename: item.filename,
        status: item.status,
        description: item.description,
        created_by: `${item.created_by_first_name} ${item.created_by_last_name}`,
        updated_by: `${item.updated_by_first_name} ${item.updated_by_last_name}`,
        signedUrl: item.signedUrl,
        revision: item.revision ? item.revision : 0
      }))
      return (
        <Table
          rowKey={record => record.id}
          columns={columns}
          dataSource={data}
          pagination={false}
        />
      )
    }
    return false
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_drawing')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('drawingId', this.state.currentId)
    formData.append('revision', 1)
    formData.append('replacement', 0)

    this.props.uploadAttachment({
      formData: formData,
      drawingId: this.state.currentId
    })
  }

  replaceAttachment = uploadParam => {
    const formData = new FormData()
    formData.append('file', uploadParam.file)
    formData.append('type', 'job_drawing')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', this.state.attachmentDescription)
    formData.append('parent_id', this.state.attachmentId)
    formData.append('revision', this.state.attachmentRevision + 1)
    formData.append('replacement', 1)
    this.props.uploadAttachment({
      formData: formData,
      drawingId: this.state.currentId,
      replacement: true
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  expandIconAttachmentTable = ({ expanded, expandable, record, onExpand }) => {
    if (!expandable || _.isEmpty(record.revisions)) {
      return null
    }
    return (
      <a onClick={e => onExpand(record, e)}>
        {expanded ? <Icon type="minus-square" /> : <Icon type="plus-square" />}
      </a>
    )
  }

  render() {
    const { contentData } = this.state

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form

    const attachments = _.get(this.props, 'jobDrawingActions.jobDrawingAttachments.data')
    const loadingAttachments = _.get(this.props, 'jobDrawingActions.loadingAttachments')

    if (!this.props.jobDrawingActions.jobDrawings) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Add/Edit Drawing"
          okText={contentData ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={950}
          maskClosable={false}
        >
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Type">
                  {getFieldDecorator('type', {
                    validateTrigger: 'onSelect',
                    rules: [
                      {
                        required: true,
                        message: 'You must choose a type'
                      }
                    ],
                    initialValue: contentData ? contentData.type : ''
                  })(<Input />)}
                </FormItem>
              </div>
            </div>
            <FormItem label="Description">
              {getFieldDecorator('description', {
                initialValue: contentData ? contentData.description : ''
              })(<TextArea />)}
            </FormItem>
            {contentData && (
              <FilesUploadContainer>
                <div className="row">
                  <div className="col-md-6">
                    <h6>
                      <Icon type="file" /> Drawing Files
                    </h6>
                  </div>
                  <div className="col-md-6 text-right">
                    {this.props.jobDrawingActions &&
                      this.props.jobDrawingActions.uploadingAttachment && (
                        <div className="text-success">
                          <Icon type="loading" /> Uploading File(s)
                        </div>
                      )}
                    {this.props.jobDrawingActions &&
                      this.props.jobDrawingActions.deletingAttachment && (
                        <div className="text-danger">
                          <Icon type="loading" /> Deleting File(s)
                        </div>
                      )}
                  </div>
                </div>
                {attachments && (
                  <Spin spinning={loadingAttachments}>
                    <Table
                      pagination={true}
                      rowKey={record => record.id}
                      columns={this.getAttachmentTableColumns()}
                      dataSource={this.getAttachmentTableData(attachments)}
                      expandedRowRender={record => this.attachmentExpandedRowRender(record)}
                      expandIcon={this.expandIconAttachmentTable}
                      onRow={record => ({
                        onClick: () => {
                          this.handleAttachmentRowClick(record)
                        }
                      })}
                    />
                  </Spin>
                )}
                {this.state.attachmentDetailsVisible && (
                  <EditAttachmentContainer>
                    <EditAttachmentTitle>
                      <Icon type="edit" /> Edit Attachment Area
                    </EditAttachmentTitle>
                    <div>
                      <EditingFileContainer>
                        <Icon type="file" /> {this.state.attachmentName}
                      </EditingFileContainer>
                    </div>
                    <div className="row">
                      <div className="col-md-10">
                        <Select
                          placeholder="Mark as..."
                          onChange={this.onStatusChange}
                          defaultValue={this.state.attachmentStatus}
                          style={{ width: 220, marginBottom: 10 }}
                        >
                          <Option value="with team">Mark as With Team</Option>
                          <Option value="with customer">Mark as With Customer</Option>
                          <Option value="with vendor">Mark as With Vendor</Option>
                          <Option value="rejected">Mark as Rejected</Option>
                          <Option value="approved">Mark as Approved</Option>
                        </Select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-10">
                        <TextArea
                          placeholder="Describe the attachment..."
                          rows={4}
                          onChange={this.onDescriptionChange}
                          value={this.state.attachmentDescription}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-row mt-2">
                      <Button onClick={this.handleUpdateAttachmentDescription}>
                        <Icon type="save" /> Save
                      </Button>{' '}
                      <Upload
                        className="ml-2"
                        {...uploadProps}
                        name="file"
                        customRequest={this.replaceAttachment}
                      >
                        <Button>
                          <Icon type="upload" /> Replace attachment
                        </Button>
                      </Upload>
                      <Popconfirm
                        title="Are you sure you want to delete this attachment?"
                        onConfirm={this.confirmAttachmentDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger" icon="delete" className="ml-2" />
                      </Popconfirm>
                    </div>
                  </EditAttachmentContainer>
                )}
                <br />
                <div>Upload Drawing File(s)</div>
                <br />
                <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                  <Button>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              </FilesUploadContainer>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Drawings
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Drawing
            </div>
          </div>
        </div>
        {this.props.jobDrawingActions.jobDrawings && (
          <Table
            pagination={false}
            rowKey={record => record.id}
            columns={this.getTableColumns()}
            dataSource={this.getTableData()}
            expandedRowRender={record => this.expandedRowRender(record)}
            onRow={record => ({
              onClick: () => {
                this.handleRowClick(record)
              }
            })}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobDrawingActions }, ownProps) => ({ jobDrawingActions })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

JobDrawings.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobDrawings)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobDrawings.js